import React from 'react'

/**
 * Publishes the enclosing `ui2:formSection`'s runtime id to descendants.
 * Read by the field shell when registering with FormFocusTargetContext so
 * `focusPath` can jump the wizard to the owning section before focusing.
 * Undefined outside of a section.
 */
export const UI2FormSectionIdContext = React.createContext<string | undefined>(undefined)
